import { FunctionalComponent, h } from '@stencil/core';
import { IIconProps } from './interfaces';

const CheckC: FunctionalComponent<IIconProps> = ({ width = '16', height = '16', fill = '#666' }) => (
  /*@ts-ignore*/
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM10.2928 15.7071C10.4881 15.9024 10.744 16 11 16C11.2559 16 11.5118 15.9024 11.7071 15.7071L17.7071 9.70711C18.0976 9.31658 18.0976 8.68342 17.7071 8.29289C17.3165 7.90237 16.6834 7.90237 16.2928 8.29289L11.3535 13.2322C11.1582 13.4275 10.8417 13.4275 10.6464 13.2322L8.70706 11.2929C8.31653 10.9024 7.68337 10.9024 7.29285 11.2929C6.90232 11.6834 6.90232 12.3166 7.29285 12.7071L10.2928 15.7071Z"
      fill={fill}
    />
  </svg>
);

export default CheckC;
